module.exports = __webpack_public_path__ + "static/favicon-14ceeedea7c51716e18a01da154dbaf3.png";